export default "__VITE_ASSET__QCRXJ_BI__"